import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { FloatingWhatsApp } from "./FloatingWhatsApp";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { AdConsentBanner } from "./AdConsentBanner";
import { trackMeasurementPage } from "../lib/google-ads";

export function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    trackMeasurementPage(pathname);
  }, [pathname]);

  return (
    <>
      <Header />
      <main id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <AdConsentBanner />
    </>
  );
}
